import queryString from 'query-string';

/**
 * Hook to retrieve the query parameters.
 * It's generic so the parameters are correctly cast.
 */
export const useQueryParameters = <T>(): T => (queryString.parse(location.search) as unknown) as T;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/hook/use-query-parameters.ts